/* Any inter component commnication other than direct PARENT-CHILD component interactions are handled
** through this common notifiation channel. Any new components need communication should declare their observable
**  sources in here and also the emit methods.
*/
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { IStickySnackbarTextSource } from '../widgets/sticky-snackbar/sticky-snackbar.component';
import { ICustomFab } from '../widgets/custom-fab/custom-fab.component';

@Injectable()
export class CommonNotificationService {

    /* ----------- Fab related notifications --------- */
    private disableFabSource = new Subject<boolean>();
    private onClickFabSource = new Subject<string>();
    private fabIconSource = new Subject<string>();
    private hideFabSource = new Subject<boolean>();
    private showMoveToRegisteSource = new Subject<boolean>();
    private fabTypeSource = new Subject<ICustomFab>();

    $disableFabSource = this.disableFabSource.asObservable();
    $onClickFab = this.onClickFabSource.asObservable();
    $fabIconSource = this.fabIconSource.asObservable();
    $hideFabSource = this.hideFabSource.asObservable();
    $showMoveToRegisterSource = this.showMoveToRegisteSource.asObservable();
    $fabTypeSource = this.fabTypeSource.asObservable();

    emitDisableFab = (disableFlag: boolean) => this.disableFabSource.next(disableFlag);
    emitOnClickFab = (code: string) => this.onClickFabSource.next(code);
    emitFabIconChange = (icon: string) => this.fabIconSource.next(icon);
    emitHideFab = (flag: boolean) => this.hideFabSource.next(flag);
    emitShowMoveToRegisterFab = (flag: boolean) => this.showMoveToRegisteSource.next(flag);
    emitFabTypeSource = (fab: ICustomFab) => this.fabTypeSource.next(fab);

    /* ---------- Sticky footer related notifications ------ */
    private stickyFooterTextSource = new Subject<IStickySnackbarTextSource>();
    private setPreviousTextSource = new Subject();
    private onClickEmailMeSource = new Subject();
    private hideCenterTextSource = new Subject();
    private showTotalAmountSource = new Subject();
    private showEmailQuoteSource = new Subject();
    private emailQuoteLayout = new Subject();


    $stickyFooterTextSource = this.stickyFooterTextSource.asObservable();
    $setPreviousTextSource = this.setPreviousTextSource.asObservable();
    $emitEmailMeClick = this.onClickEmailMeSource.asObservable();
    $hideCenterTextSource = this.hideCenterTextSource.asObservable();
    $showTotalAmountSource = this.showTotalAmountSource.asObservable();
    $showEmailQuoteSource = this.showEmailQuoteSource.asObservable();
    $emailQuoteLayout = this.emailQuoteLayout.asObservable();


    emitStickyFooterText = (data: IStickySnackbarTextSource) => this.stickyFooterTextSource.next(data);
    emitSetPreviousText = () => this.setPreviousTextSource.next();
    emitEmailMeClick = () => this.onClickEmailMeSource.next();
    emithideCenterText = (flag: boolean) => this.hideCenterTextSource.next(flag);
    emitShowTotalAmount = (flag: boolean) => this.showTotalAmountSource.next(flag);
    emitShowEmailQuote = (flag: boolean) => this.showEmailQuoteSource.next(flag);
    emitEmailQuoteLayout = (desc: string) => this.emailQuoteLayout.next(desc);

    
    /* ------------Loding spinner related notifications------- */
    private loadingSpinnerSource = new Subject<boolean>();
    $loadingSpinnerSource = this.loadingSpinnerSource.asObservable();
    emitLoadingSpinner = (flag: boolean) => this.loadingSpinnerSource.next(flag);

    /* ------------ Loading api url notifications------- */
    private urlNotificationSource = new Subject();
    $urlNotificationSource = this.urlNotificationSource.asObservable();
    emitUrlNotification = () => this.urlNotificationSource.next();

    /* ----------- UKCE control flow notifications -------- */
    private pagesupportDataArrived = new Subject();
    private courseTypesArrived = new Subject();
    private courseListArrived = new Subject();

    $pagesupportDataArrivedSource = this.pagesupportDataArrived.asObservable();
    $courseTypesArrivedSource = this.courseTypesArrived.asObservable();
    $courseListArrivedSource = this.courseListArrived.asObservable();

    emitPagesupportDataArrived = () => this.pagesupportDataArrived.next();
    emitCourseTypesArrived = () => this.courseTypesArrived.next();
    emitCourseListArrived = () => this.courseListArrived.next();

    /* quote flow notifications */
    private agentLoginSuccess = new Subject();
    public $agentLoginSuccess = this.agentLoginSuccess.asObservable();
    public emitAgentLoginSuccess = () => this.agentLoginSuccess.next();

    private schoolSelectionSuccess = new Subject();
    public $schoolSelectionSuccess = this.schoolSelectionSuccess.asObservable();
    public emitSchoolSelectionSuccess = () => this.schoolSelectionSuccess.next();

    private courseTypeSelectionSuccess = new Subject();
    public $courseTypeSelectionSuccess = this.courseTypeSelectionSuccess.asObservable();
    public emitCourseTypeSelectionSuccess = () => this.courseTypeSelectionSuccess.next();

    private courseSelectionSuccess = new Subject();
    public $courseSelectionSuccess = this.courseSelectionSuccess.asObservable();
    public emitCourseSelectionSuccess = () => this.courseSelectionSuccess.next();

    private courseEndDateSelectionSuccess = new Subject();
    public $courseEndDateSelectionSuccess = this.courseEndDateSelectionSuccess.asObservable();
    public emitCourseEndDateSelectionSuccess = () => this.courseEndDateSelectionSuccess.next();

    private packageSelectionSuccess = new Subject();
    public $packageSelectionSuccess = this.packageSelectionSuccess.asObservable();
    public emitPackageSelectionSuccess = () => this.packageSelectionSuccess.next();

    private packageEndDateSelectionSuccess = new Subject();
    public $packageEndDateSelectionSuccess = this.packageEndDateSelectionSuccess.asObservable();
    public emitPackageEndDateSelectionSuccess = () => this.packageEndDateSelectionSuccess.next();

    private accommodationSelectionSuccess = new Subject();
    public $accommodationSelectionSuccess = this.accommodationSelectionSuccess.asObservable();
    public emitAccommodationSelectionSuccess = () => this.accommodationSelectionSuccess.next();

    private updateQuoteSuccess = new Subject();
    public $updateQuoteSuccess = this.updateQuoteSuccess.asObservable();
    public emitUpdateQuoteSuccesss = () => this.updateQuoteSuccess.next();
}



// WEBPACK FOOTER //
// ./src/app/services/common-notification.service.ts